import React from 'react';
import { useTranslation } from 'react-i18next';

import { LiliButton } from '@lili/lili-frontend-common';
import { CloseButton } from '../../../DesignSystem/LiliCloseButton/CloseButton';
import { AppointAdminTerms } from './terms/AppointAdminTerms';
import { InviteFormTermsType } from '../pages/TeamMemberDetails/components/InviteTermsCheckbox';
import { AccountantInviteTerms } from './terms/AccountantInviteTerms';
import { CorporateResolutionTerms } from './terms/CorporateResolutionTerms';
import { ISummaryData, RoleType } from '../../../types';
import useStore from '../../../store';

interface IProps {
  type: InviteFormTermsType;
  inviteEmail: string;
  inviteName: string;
  onClose: () => void;
}

export const Terms = ({ type, inviteEmail, inviteName, onClose }: IProps) => {
  const { t } = useTranslation();
  const {
    customer: { firstName, lastName },
    business: { name: businessName },
    teamMembers,
  }: ISummaryData = useStore((state) => state.summary);

  const ubos = teamMembers
    .filter((member) => member.teamMemberType === RoleType.UBO)
    .map((member) => `${member.firstName} ${member.lastName}`);
  return (
    <button
      className='fixed fadeIn inset-0 bg-bw08 flex items-center justify-center bg-opacity-80 h-full z-[9999]'
      title=''
      id=''
      type='button'
      onClick={() => onClose()}
    >
      <div className='cursor-default flex flex-col items-start justify-between w-[70%] h-[90%]  max-w-[1047px] overflow-hidden bg-bw00 rounded-[12px] rounded-tl-[12px] '>
        <div className='w-full justify-end pt-[18px] pr-[14px] flex'>
          <CloseButton onClick={onClose} className=' w-[32px] hover:cursor-pointer ' id='closeFlow' />
        </div>
        <div className='w-full overflow-y-scroll h-full'>
          <div className='w-full px-[100px] pt-[40px] pb-[36px]'>
            {type === InviteFormTermsType.ACCOUNTANT_VIEWER_TERMS && <AccountantInviteTerms />}
            {type === InviteFormTermsType.ADMIN_CORPORATE_RESOLUTION && (
              <CorporateResolutionTerms
                accountUBOs={ubos}
                businessName={businessName || `${firstName} ${lastName}`}
                primaryOwnerName={`${firstName} ${lastName}`}
              />
            )}
            {type === InviteFormTermsType.APPOINT_ADMIN && (
              <AppointAdminTerms
                businessName={businessName || ''}
                administratorName={inviteName}
                administratorEmail={inviteEmail}
                primaryOwnerName={`${firstName} ${lastName}`}
              />
            )}
          </div>
        </div>
        <div className='flex justify-center w-full border-t border-t-bw03 py-[24px] shadow-shadowTop'>
          <LiliButton
            id=''
            title={t('INVITE_ACCOUNTANT.START.CTA_CLOSE_DISCLAIMER')}
            onClick={onClose}
            className='max-w-[298px]'
          />
        </div>
      </div>
    </button>
  );
};
